import { motion } from 'framer-motion';

export default function PageLoader() {
  return (
    <div className="fixed inset-0 bg-bg-primary flex items-center justify-center z-50">
      <motion.div
        className="flex gap-2"
        initial="hidden"
        animate="visible"
        variants={{ visible: { transition: { staggerChildren: 0.15 } } }}
      >
        {[0, 1, 2].map((i) => (
          <motion.span
            key={i}
            className="w-2 h-2 rounded-full bg-accent"
            variants={{
              hidden: { opacity: 0.2, y: 0 },
              visible: { opacity: [0.2, 1, 0.2], y: [0, -8, 0], transition: { duration: 1, repeat: Infinity, ease: 'easeInOut' } },
            }}
          />
        ))}
      </motion.div>
    </div>
  );
}